import { Button } from '@chakra-ui/button'
import { useColorMode } from '@chakra-ui/color-mode'
import { Stack, Circle, Flex, Box, Text } from '@chakra-ui/layout'
import { useMediaQuery } from '@chakra-ui/media-query'
import { Collapse, Center } from '@chakra-ui/react'
import Lottie from 'react-lottie'
import animationData from './work.json'
import React from 'react'
import '../index.css'
function Header() {
  const [show, setShow] = React.useState(false)
  const handleToggle = () => setShow(!show)
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid scale',
    },
  }
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  const [isNotSmallerScreen] = useMediaQuery('(min-width:450px)')

  return (
    <Stack>
      <Circle
        position='absolute'
        bg='blue.100'
        opacity='0.1'
        w='300px'
        h='300px'
        alignSelf='flex-end'
      />
      <Flex
        direction={isNotSmallerScreen ? 'row' : 'column'}
        spacing='200px'
        p={isNotSmallerScreen ? '32' : '0'}
        alignSelf='flex-start'
      >
        <Box mt={isNotSmallerScreen ? '0' : 16} align='flex-start'>
          <Text fontSize='5xl' fontWeight='semibold'>
            Hi, 👋 I'm
          </Text>
          <Text
            fontSize='6xl'
            fontWeight='bold'
            bgGradient='linear(to-r, cyan.400, blue.500, purple.600)'
            bgClip='text'
            className='header__name'
          >
            Sharma Ketan
          </Text>
          <Collapse
            startingHeight={190}
            in={show}
            color={isDark ? 'gray.200' : 'gray.500'}
          >
            <Text
              color={isDark ? 'gray.200' : 'gray.500'}
              fontWeight='bold'
              bgGradient='linear(to-r, red.400, blue.500, cyan.600)'
              bgClip='text'
              fontSize='1xl'
              maxW='4xl'
              fontFamily='poppins'
            >
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Aspiring
              Full Stack Developer | Coding for me is like MAGIC 🌱 | You have
              no barriers to showcase your creativity | There are an unlimited
              amount of things to learn in the coding community | I was a
              computer freak, playing games was one of my things to do | As I
              grew older, I thought to pursue coding | I guess print("Hello
              World") is first step to pursue coding | Things went by,
              accomplished certification in Bachelor of Business Administration
              in Computer Application.
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Started to
              learn new Tools | Frameworks | Libraries and explore the
              community. Throughout my college days, I latched on to any ideas
              for projects I could get, moving from "Hello World" all the way to
              creating interactive websites like "GINGER FRESH", with dozens of
              projects in between. <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The
              INTERNET, it was here that I learned truly how much there was yet
              to learn. I landed an internship as a .Net Developer to understand
              the industry. So, now, in an industry that is growing at a rapid
              speed, this passion remains with me. There's certainly yet more to
              learn, yet more problems to solve, and yet more to build. And for
              this, I am very grateful. When you have an emotional component to
              something you tend to recall it vividly. <hr />
              <Center
                fontSize='2xl'
                className='header__quote'
                bgGradient='linear(to-r, cyan.900, blue.500, red.600)'
                bgClip='text'
              >
                <b>I'm pretty sure I'm worthless if I can't be of service</b>
              </Center>
            </Text>
          </Collapse>
          <Button size='sm' onClick={handleToggle} mt='1rem'>
            Show {show ? 'Less' : 'More'}
          </Button>
          <br />
          <Button
            mt={8}
            colorScheme='blue'
            onClick={() =>
              window.open('https://www.linkedin.com/in/sharmaketann')
            }
          >
            Connect with Me 🔥
          </Button>
        </Box>
        <div>
          <Lottie
            options={defaultOptions}
            mt={isNotSmallerScreen ? '0' : '12'}
            mb={isNotSmallerScreen ? '0' : '12'}
          />
        </div>
      </Flex>
    </Stack>
  )
}

export default Header
